// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var DateFns = require("date-fns");
var Core__List = require("@rescript/core/src/Core__List.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var List__Jsx3 = require("../../../uikit/reason/atoms/List/List__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Theme__Color__Vars = require("../../../reason/common/Theme/Theme__Color__Vars.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizard__WarningHeader = require("./PropertyWizard__WarningHeader.bs.js");
var PropertyWizardRelayRebroadcastWarning_draft_graphql = require("../../../__generated__/PropertyWizardRelayRebroadcastWarning_draft_graphql.bs.js");

var convertFragment = PropertyWizardRelayRebroadcastWarning_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayRebroadcastWarning_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayRebroadcastWarning_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayRebroadcastWarning_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayRebroadcastWarning_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__RebroadcastWarning(props) {
  var policy = props.policy;
  var match = PropertyWizardFormRelay.Context.use();
  var mode = match.mode;
  var draft = use(props.draft);
  var match$1 = React.useState(function () {
        return false;
      });
  var hasHadLocallyValidPrice = match$1[0];
  var exit = 0;
  var exit$1 = 0;
  if (typeof mode !== "object" || mode.TAG !== "Rebroadcast") {
    exit$1 = 3;
  } else {
    switch (policy.__typename) {
      case "PropertyBroadcastAllowed" :
          exit$1 = 3;
          break;
      case "PropertyBroadcastNotAllowed" :
          return "This property cannot be rebroadcast";
      case "__unselected" :
          return null;
      
    }
  }
  if (exit$1 === 3) {
    switch (policy.__typename) {
      case "PropertyBroadcastAllowed" :
          var match$2 = policy.priceCondition;
          if (match$2 === undefined) {
            return null;
          }
          if (match$2.currentPriceQualifies) {
            return null;
          }
          var requiredUntil = match$2.requiredUntil;
          var match$3 = match$2.maxPrice;
          var maxPrice = match$3.value;
          var match$4 = draft.draftProperty;
          var price = match$4.minPrice;
          var hasLocallyValidPrice;
          var exit$2 = 0;
          var price$1 = match$4.price;
          if (price$1 !== undefined && !match$4.priceRange) {
            hasLocallyValidPrice = price$1 <= maxPrice;
          } else {
            exit$2 = 4;
          }
          if (exit$2 === 4) {
            hasLocallyValidPrice = price !== undefined && match$4.priceRange ? price <= maxPrice : false;
          }
          if (!hasLocallyValidPrice && !hasHadLocallyValidPrice) {
            var priceBullet = "If the price is lowered by 5% (to " + match$3.formatted + ") or more, you can rebroadcast immediately.\n                      This is to give advance notice, so only rebroadcast if the price drop is not yet on the MLS.";
            var nextBroadcastDateBullet = Core__Option.map(requiredUntil, (function (date) {
                    var date$1 = DateFns.format(CalendarDate.toLocalDate(date), "MMMM do");
                    return "This property will be eligible for rebroadcasting on " + date$1;
                  }));
            var mlsTimingInfoBullet = requiredUntil !== undefined ? undefined : "Since this property was not originally entered at least 3 days before going Active on the MLS, it can only be rebroadcast\n                 if the price is lowered by 5% or more. Use the blue messenger at the bottom right if you have any questions.";
            return JsxRuntime.jsx(PropertyWizard__WarningHeader.make, {
                        icon: JsxRuntime.jsx(Icon__Jsx3.make, {
                              icon: "AttentionAlt",
                              size: 30,
                              color: Theme__Color__Vars.black
                            }),
                        headingText: "This property is not currently eligible to be rebroadcast",
                        variant: "Error",
                        children: JsxRuntime.jsx(List__Jsx3.make, {
                              items: Core__List.filterMap({
                                    hd: nextBroadcastDateBullet,
                                    tl: {
                                      hd: priceBullet,
                                      tl: {
                                        hd: mlsTimingInfoBullet,
                                        tl: /* [] */0
                                      }
                                    }
                                  }, (function (x) {
                                      return x;
                                    }))
                            })
                      });
          }
          if (hasLocallyValidPrice && !hasHadLocallyValidPrice) {
            match$1[1](function (param) {
                  return true;
                });
          }
          return null;
          break;
      case "PropertyBroadcastNotAllowed" :
      case "__unselected" :
          exit = 2;
          break;
      
    }
  }
  if (exit === 2 && typeof mode === "object" && mode.TAG === "Edit") {
    return null;
  }
  switch (policy.__typename) {
    case "PropertyBroadcastNotAllowed" :
        return "This property cannot be broadcast";
    case "PropertyBroadcastAllowed" :
    case "__unselected" :
        return null;
    
  }
}

var make = PropertyWizardRelay__RebroadcastWarning;

exports.DraftFragment = DraftFragment;
exports.make = make;
/* react Not a pure module */
